<template>
  <v-card>
    <v-toolbar dense flat color="primary" dark>
      <v-toolbar-title>供应商管理</v-toolbar-title>
    </v-toolbar>
    <v-container v-if="loading" class="text-center">
      <v-progress-circular class="text-center mx-auto" color="primary" indeterminate/>
    </v-container>
    <v-tabs v-else vertical v-model="selectedIndex">
      <v-tab style="justify-content: left" v-for='provider of providers' :key='provider.providerName'>
        {{ provider.providerName }}
      </v-tab>
      <v-tab-item v-for='(provider, index) of providers' :key='provider.providerName'>
        <v-card flat>
          <v-form :ref="'form' + index" lazy-validation>
            <v-card-text>
              <v-row>
                <v-col>时效(如果仓库没有额外时效, 则会显示该时效):</v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field type="number" dense label="最短时效" suffix="天" hide-details v-model="provider.minTime"/>
                </v-col>
                <v-col>
                  <v-text-field type="number" dense label="最长时效" suffix="天" hide-details v-model="provider.maxTime"/>
                </v-col>
              </v-row>
              <div v-if="provider.fees && provider.fees.length > 0">
                <v-row>
                  <v-col>价格列表:</v-col>
                </v-row>
                <v-row v-for="(fee, index) of provider.fees" :key='fee.id'>
                  <v-col>
                    <v-text-field placeholder="收费项" dense hide-details v-model="fee.name" :rules="rules.required"/>
                  </v-col>
                  <v-col>
                    <v-select placeholder="计费类型" dense hide-details :items="feeTypes"
                              v-model="fee.type" :rules="rules.required"/>
                  </v-col>
                  <v-col>
                    <v-text-field type="number" dense label="价格" suffix="元" v-model="fee.price"
                                  append-outer-icon="mdi-minus"
                                  :append-icon="index === provider.fees.length - 1 ? 'mdi-plus' : ''"
                                  :rules="rules.required"
                                  @click:append="addFee" @click:append-outer="removeFee(index)"/>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row>
                  <v-col>价格列表:</v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn color="primary" small @click="addFee">新增计费项目</v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col>
                  <v-textarea placeholder="请输入备注, 如果仓库没有额外备注, 则会显示该备注" hide-details v-model="provider.remark"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>仓库列表:</v-col>
              </v-row>
              <v-row v-for="channel of provider.channels" :key='channel.id'>
                <v-col>
                  {{ channel.channelType }} - {{ channel.repository }}
                </v-col>
                <v-col>
                  <v-text-field type="number" dense label="最短时效" suffix="天" hide-details v-model="channel.minTime"/>
                </v-col>
                <v-col>
                  <v-text-field type="number" dense label="最长时效" suffix="天" hide-details v-model="channel.maxTime"/>
                </v-col>
                <v-col>
                  <v-textarea dense placeholder="仓库备注" hide-details rows="2" v-model="channel.remark"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <v-btn class="success" small @click="save" :loading="loading">保存</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-dialog v-model="addProviderDialog" persistent width="unset">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" small v-bind="attrs" v-on="on">
            <v-icon small>mdi-plus</v-icon>
            新增供应商
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="text-h5">新增供应商</span>
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="newProviderName" label="供应商名称"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" text @click="closeProviderDialog">关闭</v-btn>
            <v-btn color="primary" text @click="addProvider">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer/>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ProviderCard",
  props: {
    channel: Object
  },
  computed: {
    selected() {
      if (this.providers && this.providers.length > 0) {
        return this.providers[this.selectedIndex]
      }
      return {}
    }
  },
  data() {
    return {
      loading: true,
      selectedIndex: null,
      addProviderDialog: false,
      newProviderName: null,
      providers: [],
      feeTypes: [
        {value: 1, text: '固定费用'},
        {value: 2, text: '按重量计费'}
      ],
      rules: {
        required: [
          v => !!v || '此项必填!'
        ]
      }
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.providers = []
      this.selectedIndex = null
      this.$axios.get('/channel/providerInfos', {
        params: {
          country: this.channel.country,
          channel: this.channel.name
        }
      }).then(res => {
        this.loading = false
        this.providers = res.data
        console.log(this.providers)
      })
    },
    addFee() {
      if (this.selected) {
        this.selected.fees.push({
          country: this.selected.country,
          providerName: this.selected.providerName,
          channelName: this.selected.channelName,
          type: 1,
          price: null
        })
      }
    },
    removeFee(index) {
      if (this.selected) {
        this.selected.fees.splice(index, 1)
      }
    },
    addProvider() {
      let newProvider = JSON.parse(JSON.stringify(this.selected))
      newProvider.providerName = this.newProviderName
      newProvider.fees = []
      newProvider.minTime = null
      newProvider.maxTime = null
      newProvider.remark = null

      for (let channel of newProvider.channels) {
        channel.id = null
        channel.providerName = this.newProviderName
        channel.minTime = null
        channel.maxTime = null
        channel.remark = null
      }

      this.providers.push(newProvider)
      this.selectedIndex = this.providers.length - 1
      this.selected = this.providers[this.selectedIndex]

      this.closeProviderDialog()
    },
    closeProviderDialog() {
      this.newProviderName = null
      this.addProviderDialog = false
    },
    save() {
      if (this.$refs['form' + this.selectedIndex][0].validate()) {
        this.loading = true
        this.$axios.patch('/provider', this.selected).then(() => {
          this.loading = false
          this.$bus.$emit('msg', '保存成功!')
          this.getData()
        }).catch(err => {
          this.$bus.$emit('msg', `出错: ${err}`, 'error')
        })
      }
    }
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>

</style>